import React, { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker';
import ReactTooltip from "react-tooltip";
import { FormattedMessage } from 'react-intl/dist';
import Spinner from '../common/spinner/Spinner';
import UpcomingDueDate from './UpcomingDueDate';
import BarChart from './BarChart'
import useChartInfo from './useChartInfo'
import { CHART_CONST_INFO } from '../../constants/common/chart/chartConst';
import { formatDate } from '../../utils/dates/date.utils';
import { MM_SLASH_DD_SLASH_YYYY } from '../../utils/dates/dateFormats.utils';

function UpcomingDueDateContainer() {
    const [serviceResponse, setServiceResponse] =useState<any[]>([]);
    const [defaultReportCoolers, setDefaultReportCoolers] =useState<string[]>(CHART_CONST_INFO.STATUS_REPORTS_COLOR);
    const [showAssigneeSegment, setshowAssigneeSegment] = useState(false);
    const [selectedReport, setSelectedReport] = useState<string>(CHART_CONST_INFO.UPCOMING_DUE_DATES);
    const [selectedDate, setSelectedDate] = useState<Date>();
    const [selectedChart, setselectedChart] = useState<string>(CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_STATUS);
    const [chartData, setchartData] = useState<any[]>([]);
    const [idMapping, setidMapping] = useState<{}[]>([]);
    const [selectedWorkGropeName, setSelectedWorkGropeName] = useState<string>('');
    const [chartName, setchartName] = useState("");
    const [workgroupSelected, setworkgroupSelected] = useState<number>();
    const [chartColors, setChartColors] = useState<string[]>(CHART_CONST_INFO.STATUS_REPORTS_COLOR);
    const [isLegendFilterApplied, setIsLegendFilterApplied] = useState<string | null>(null);
    const [isWorkGroupFilterApplied, setIsWorkGroupFilterApplied] = useState<number>(-1);
    const [legendClassName, setLegendClassName] = useState<string[]>(['na']);
    const [isDrillDownActive, setIsDrillDownActive]  = useState<boolean>(false);
    const [segmentBy, setSegmentBy] = useState<string>(CHART_CONST_INFO.TAB_STATUS);
    const[workGroupFilter, setworkGroupFilter ]=useState<any>(-1);

    const { chartInfoData, fetchDueDateByWorkGroup, startSpinner,
        stopSpinner,
        fetchResolvedDateReportsByWorkGroup,
        fetchResolvedDateReportsGroupByAssigneeForAssigneeIdDrillDown,
        getResolvedDateReportsGroupByAssignee,
        getResolvedDateReportsGroupByAssigneeForAssigneeIdDrillDown
    } = useChartInfo();

    const isStatusChart = selectedChart === CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_STATUS;
    const isStatusChartByUser = selectedChart === CHART_CONST_INFO.ACTIVATE_STATUS_BY_USERS;


    let tStatusRef: any = null;

    useEffect(()=>{
        const chartColorsInfo: string[] = selectedReport !== CHART_CONST_INFO.UPCOMING_DUE_DATES ? CHART_CONST_INFO.RESOLVED_DATE_REPORTS_COLOR
        : (isStatusChart || isStatusChartByUser)
            ? CHART_CONST_INFO.STATUS_REPORTS_COLOR
            : CHART_CONST_INFO.DUEDATE_DATE_REPORTS_COLOR;
        
        if (isLegendFilterApplied && chartData.length > 0) {
            const selectedIndex = serviceResponse[0]?.indexOf(chartData[0][1]);
            switch (segmentBy) {
                case CHART_CONST_INFO.TAB_STATUS: {
                    setChartColors([CHART_CONST_INFO.STATUS_REPORTS_COLOR[selectedIndex-1]]);
                    break;
                }
                case CHART_CONST_INFO.TAB_DUE_DATE: {
                    setChartColors([CHART_CONST_INFO.DUEDATE_DATE_REPORTS_COLOR[selectedIndex-1]]);
                    break;
                }
                case CHART_CONST_INFO.ASSIGNEE :
                case CHART_CONST_INFO.WORKGROUP : {
                    setChartColors([CHART_CONST_INFO.RESOLVED_DATE_REPORTS_COLOR[selectedIndex-1]]);
                    break;
                }
                default:
                    setChartColors(chartColorsInfo);
                    setDefaultReportCoolers(chartColorsInfo);
                    break;
            }
        } else {
            setChartColors(chartColorsInfo);
            setDefaultReportCoolers(chartColorsInfo);
        }
    },[chartData])

    useEffect(()=>{
        if(selectedReport === CHART_CONST_INFO.UPCOMING_DUE_DATES) {
            upcomingDueDateStateChange()
        } else {
            upcomingResolvedTodayReport()
        }
    },[segmentBy])

    const changeReport = (value) => {
        clearFilters();
        setchartData([]);
        setServiceResponse([])
        setSelectedReport(value);
        if (value === CHART_CONST_INFO.UPCOMING_DUE_DATES) {
            setshowAssigneeSegment(false);
            setSegmentBy(CHART_CONST_INFO.TAB_STATUS)
        } else {
            const  activeTabInfo = CHART_CONST_INFO.WORKGROUP;
            setSegmentBy(activeTabInfo)
        }

    };

    const getWorkNameOrAssigneeName = (id) => {
        let filterItem: any= '';
        Object.entries(idMapping).forEach((value): void=> {
            Object.entries(value[1]).forEach((item): void => {
                if (item[0] === id) {
                    filterItem = item[1];
                 }
            })
        })
        return filterItem;
    }

    const upcomingDueDateStateChange=()=>{
        clearFilters();
        if (!isDrillDownActive) {
            const segmentBySelection = segmentBy === CHART_CONST_INFO.TAB_STATUS  ?   CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_STATUS : CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_DUEDATE ;
            setselectedChart(segmentBySelection);
            fetchDataFromApi(segmentBySelection, null, selectedDate);
        }
    }

    const upcomingResolvedTodayReport=()=>{
        clearFilters();
        if (!isDrillDownActive) {
            const segmentBySelection = segmentBy === CHART_CONST_INFO.ASSIGNEE  ?   CHART_CONST_INFO.RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE : CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_DUEDATE_RESOLVED_TODAY ;
            setselectedChart(segmentBySelection);
            fetchDataFromApi(segmentBySelection, null, selectedDate, selectedReport);
        }
    }

    const clearFilters=()=>{
        setIsLegendFilterApplied(null);
        setIsWorkGroupFilterApplied(-1);
        setworkGroupFilter(-1);
    };
    
    const applyLegendFilter=(legendFilter)=>{
        const legendFilterData: any= [];
        legendFilterData.push([serviceResponse[0][0],legendFilter]);
        const selectedIndex = serviceResponse[0].indexOf(legendFilter); 
        serviceResponse.forEach((rowData, serverIndex)=>{
            if(serverIndex > 0 ) {
                rowData.forEach((element, index) => {
                    if(index === selectedIndex) {
                        legendFilterData.push([rowData[0], element]);
                    }
                });
            }
        })
        return legendFilterData;
    }
    const applyWorkgroupFilter=(workGroupFilter, filterList=serviceResponse)=>{
        const filterName = getWorkNameOrAssigneeName(workGroupFilter);
        const workgroupFilteredChartData:any=[]
        workgroupFilteredChartData.push(filterList[0]);
        const data: any = filterList?.filter((value, index)=>index > 0 && value[0] === filterName)
        workgroupFilteredChartData.push(...data);
        return workgroupFilteredChartData;
    }

    const multipleFilterApplied =(legendFilter, workGroupFilter) => {
        const legendFilteredData = applyLegendFilter(legendFilter);
        const workgroupFilteredData = applyWorkgroupFilter(workGroupFilter, legendFilteredData);
        setchartData(workgroupFilteredData);
    }

    const filterBasedOnLegend=(e, legendFilter)=>{
        const indexId = e.target.id;
        if(legendClassName[indexId] === '--clickable') {
            setIsLegendFilterApplied(legendFilter);
            const legendClassNameUpdated = legendClassName.map((_item,index) => Number(index) === Number(indexId) ? '--clicked' : '--clickable')
            setLegendClassName(legendClassNameUpdated);
            if (isWorkGroupFilterApplied > -1) {
                multipleFilterApplied(legendFilter, isWorkGroupFilterApplied) 
            } else {
                const legendFilterData = applyLegendFilter(legendFilter);
                setchartData(legendFilterData);
            }
        } else {
            legendClassName[indexId] = '--clickable';
            setLegendClassName(legendClassName);
            clearFilters();
            setchartData(serviceResponse);
        }
    }

    const filterBySelectedWorkGroup=(workGroupFilter) => {
        if(Number(workGroupFilter) === -1) {
            clearFilters();
            setchartData(serviceResponse);
        } else {
            setworkGroupFilter(workGroupFilter)
            setIsWorkGroupFilterApplied(workGroupFilter);
            if(isLegendFilterApplied) {
                multipleFilterApplied(isLegendFilterApplied,workGroupFilter);
            } else {
                if(workGroupFilter > -1) {
                    const workgroupFilterData = applyWorkgroupFilter(workGroupFilter);
                    setchartData(workgroupFilterData);
                } else {
                    setchartData(serviceResponse);
                }
            }

        }
    }

    const onSelectedDate = date => {
        clearFilters();
        const changedDate = date ? formatDate(new Date(date), MM_SLASH_DD_SLASH_YYYY) : '';
        const workgroupName = workgroupSelected;
        startSpinner()
        fetchDataFromApi(selectedChart, workgroupName, changedDate);
        setSelectedDate(date);
    }


    const loadChartData = (response) => {
        stopSpinner()
        const formattedData: any[] = []
        const idMapping = response?.responseBody?.idMapping
        const category = response?.responseBody?.category;
        const responseData = response?.responseBody?.responseData;
        formattedData.push(category)
        if (responseData) {
            responseData.forEach((data: {}) => {
                const responseArray: any[] = []
                idMapping.forEach((item: object) => {
                    const value = item[Number(Object.keys(data)[0])]
                    if (value) {
                        responseArray.push(value);
                    }
                });
                responseArray.push(...data[Object.keys(data)[0]])
                formattedData.push(responseArray)
            })
        }
        const numberOfLegendClass = formattedData?.filter((v,i)=> i===0)[0].filter((v,i)=> i>0).map(v=>'--clickable');
        setLegendClassName(numberOfLegendClass);
        setchartData(formattedData);
        setServiceResponse(formattedData);
        setidMapping(idMapping);
        if (selectedReport && selectedReport === CHART_CONST_INFO.UPCOMING_DUE_DATES) { 
            setSelectedDate(response?.resultDate ? new Date(response?.resultDate) : new Date());
        }
    }

    const fetchDataFromApi = (selectedChart: string, workgroupName?: number | null, selectedDate?: any, selectedReport :any=CHART_CONST_INFO.UPCOMING_DUE_DATES) => {
        setchartData([]);
        setServiceResponse([])
        if (selectedReport && selectedReport !== CHART_CONST_INFO.UPCOMING_DUE_DATES) {
            if (selectedChart === CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_DUEDATE_RESOLVED_TODAY) {
                setchartName(CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_DUEDATE_RESOLVED_TODAY)
                fetchResolvedDateReportsByWorkGroup().then((response) => {
                    setshowAssigneeSegment(response?.showAssigneeSegment);
                    loadChartData(response)
                });
            } else if (selectedChart === CHART_CONST_INFO.RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE) {
                setchartName(CHART_CONST_INFO.RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE)
                getResolvedDateReportsGroupByAssignee().then((response) => {
                    loadChartData(response)
                });
            } else if (selectedChart === CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_DUEDATE_RESOLVED_TODAY_ASSIGNEE_DRILL_DOWN) {
                const requestBody = { workGroupId: workgroupName } 
                setchartName(CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_DUEDATE_RESOLVED_TODAY_ASSIGNEE_DRILL_DOWN)
                fetchResolvedDateReportsGroupByAssigneeForAssigneeIdDrillDown(requestBody).then((response) => {
                    loadChartData(response)
                });
            } else if (selectedChart === CHART_CONST_INFO.RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN) {
                const requestBody = { assignee: workgroupName }
                setchartName(CHART_CONST_INFO.RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN)
                getResolvedDateReportsGroupByAssigneeForAssigneeIdDrillDown(requestBody).then((response) => {
                    loadChartData(response)
                });
            }
        } else if(selectedReport && selectedReport === CHART_CONST_INFO.UPCOMING_DUE_DATES) {
            const isDueDateChart = selectedChart === CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_DUEDATE;
            const isDueDateChartByUser = selectedChart === CHART_CONST_INFO.ACTIVATE_DUEDATE_BY_USERS;
            const isStatusChart = selectedChart === CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_STATUS;
            const isStatusChartByUser = selectedChart === CHART_CONST_INFO.ACTIVATE_STATUS_BY_USERS;
            if (isDueDateChart) {
                setchartName(CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_DUEDATE)
            } else if (isDueDateChartByUser) {
                setchartName(CHART_CONST_INFO.ACTIVATE_DUEDATE_BY_USERS)
            } else if (isStatusChart) {
                setchartName(CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_STATUS)
            } else if (isStatusChartByUser) {
                setchartName(CHART_CONST_INFO.ACTIVATE_STATUS_BY_USERS)
            }
            setchartName(isDueDateChart ? CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_DUEDATE
                : isStatusChart ? CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_STATUS
                    : isDueDateChartByUser ? CHART_CONST_INFO.ACTIVATE_DUEDATE_BY_USERS
                        : isStatusChartByUser ? CHART_CONST_INFO.ACTIVATE_STATUS_BY_USERS : '')
            const requestBody = {
                activeChart: isDueDateChart ? CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_DUEDATE
                    : isStatusChart ? CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_STATUS
                        : isDueDateChartByUser ? CHART_CONST_INFO.ACTIVATE_DUEDATE_BY_USERS
                            : isStatusChartByUser ? CHART_CONST_INFO.ACTIVATE_STATUS_BY_USERS : '',
                workgroup: workgroupName || '',
                dueDate: selectedDate ? formatDate(new Date(selectedDate), MM_SLASH_DD_SLASH_YYYY) : '',
            }
            fetchDueDateByWorkGroup(requestBody).then((response: any) => {
                loadChartData(response);
            })
        }
    }

    const backToDetailedReport = () => {
        setIsDrillDownActive(false);
        clearFilters()
        toWorkgroupChart(segmentBy, selectedReport)
    }

    const toWorkgroupChart = (segmentBy: string, value?: any) => {
        let selectedChart = CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_DUEDATE;
        if (value && value !== CHART_CONST_INFO.UPCOMING_DUE_DATES) {
            selectedChart = segmentBy === CHART_CONST_INFO.ASSIGNEE && showAssigneeSegment ? CHART_CONST_INFO.RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE : CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_DUEDATE_RESOLVED_TODAY;
        } else {
            selectedChart = segmentBy === CHART_CONST_INFO.TAB_DUE_DATE ? CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_DUEDATE : CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_STATUS;
        }
        setselectedChart(selectedChart);
        startSpinner()
        fetchDataFromApi(selectedChart, null, selectedDate, value);
    }

    const getWorkIdOrAssigneeId = (parts) => {
        return Number(Object.keys(idMapping?.filter((acc: {}, index) => {
            if (index === Number(parts)) {
                return Object.keys(acc)[0];
            }
        })[0])[0])
    }


    const getFilter = (parts) => {
        const isDueDateChart = selectedChart === CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_DUEDATE;
        const isDueDateChartByUser = selectedChart === CHART_CONST_INFO.ACTIVATE_DUEDATE_BY_USERS;
        const isTodayActivityReport = segmentBy === CHART_CONST_INFO.ASSIGNEE || segmentBy === CHART_CONST_INFO.WORKGROUP

        if (isLegendFilterApplied) {
            const filterIndex = legendClassName.map(v => v === '--clicked').indexOf(true);
            if (isDueDateChart || isDueDateChartByUser) {
                return CHART_CONST_INFO.DUEDATE_FILTER_LIST[filterIndex];
            } else if (isTodayActivityReport) {
                return CHART_CONST_INFO.TODAYS_ACTIVITY_LIST[filterIndex]
            } else {
                return CHART_CONST_INFO.STATUS_FILTER_LIST[filterIndex];
            }
        }
        if (isDueDateChart || isDueDateChartByUser) {
            return CHART_CONST_INFO.DUEDATE_FILTER_LIST[parts[1]];
        } else if (isTodayActivityReport) {
            return CHART_CONST_INFO.TODAYS_ACTIVITY_LIST[parts[1]]
        } else {
            return CHART_CONST_INFO.STATUS_FILTER_LIST[parts[1]];
        }

    }

    const getWorkGroupId = (parts) => {
        let workGroupId;
        workGroupId = Number(Object.keys(idMapping?.filter((acc: {}, index) => {
            if (index === Number(parts[2])) {
                return Object.keys(acc)[0];
            }
        })[0])[0])

        return workGroupId;
    }

    const getFilterWorkGroupOrAssignee = (isResolvedTodayReport, parts, getAssignee: boolean=false)=>{
        let id: any = 0;
        const isWorkGroupDrillDown: boolean = selectedChart === CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_DUEDATE_RESOLVED_TODAY_ASSIGNEE_DRILL_DOWN;
        if (!isResolvedTodayReport) {
            if (getAssignee) {
                id = isDrillDownActive  ? getWorkIdOrAssigneeId(parts[2]) : ''
                return id
            }
            if( workGroupFilter != -1) {
                return workGroupFilter
            }
            id = isDrillDownActive ? workgroupSelected : getWorkIdOrAssigneeId(parts[2]) 
            return id
        } else {
            if (getAssignee) {
                if (isDrillDownActive && !isWorkGroupDrillDown) {
                    id =  workgroupSelected
                    return id
                } else {
                    if (selectedChart === CHART_CONST_INFO.RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE) {
                        id =  getWorkGroupId(parts);
                        return id
                    }
                    return isDrillDownActive ? getWorkIdOrAssigneeId(parts[2]) : ''
                }
            } else {
                if (isDrillDownActive && isWorkGroupDrillDown) {
                    id =  workgroupSelected
                    return id
                } else {
                    if (selectedChart === CHART_CONST_INFO.RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE) {
                        id = isDrillDownActive ? workgroupSelected : '' 
                        return id
                    }
                    id = getWorkGroupId(parts) 
                    return id
                }
            }
        }
    };

    const toUserChart = (e) => {
        const isDueReport = selectedChart === CHART_CONST_INFO.ACTIVATE_DUEDATE_BY_USERS || selectedChart === CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_DUEDATE
        const isResolvedTodayReport: boolean  = selectedReport !== CHART_CONST_INFO.UPCOMING_DUE_DATES;
        const parts = e.targetID.split("#");
        if (parts[0] === 'bar') {
            const ticketListSortFromChart = {
                dueReport: isDueReport ? 'yes' : 'no',
                pageNumber: 1,
                pageSize: 10,
                sortOrder: 'DESC',
                sortBy: 'assignee',
                workgroupId: getFilterWorkGroupOrAssignee(isResolvedTodayReport, parts),
                filter: getFilter(parts),
                assigneeId: getFilterWorkGroupOrAssignee(isResolvedTodayReport, parts, true),
                dueDate: selectedDate ? formatDate(new Date(selectedDate), MM_SLASH_DD_SLASH_YYYY) : '',
                resolvedReport: isResolvedTodayReport ? true : false
            }
            startSpinner()
            sessionStorage.setItem('ticketListSortFromChart', JSON.stringify(ticketListSortFromChart));
            window.location.href = '/hix/ticketmgmt/ticket/ticketlist?dueDateRepost=true'
        }
        if (!isDrillDownActive && parts[0] === 'hAxis') {
            clearFilters()
            if (parts.indexOf("label") >= 0) {
                let idx = parts[parts.indexOf("label") + 1];
                idx = parseInt(idx);
                setSelectedWorkGropeName(chartData[idx + 1][0]);
                const workgroupId: number = Number(Object.keys(idMapping?.filter((acc: {}) => Object.values(acc)[0] === chartData[idx + 1][0])[0])[0]);
                setworkgroupSelected(workgroupId);
                startSpinner()
                if (selectedReport && selectedReport !== CHART_CONST_INFO.UPCOMING_DUE_DATES) {
                    const activeChart = (showAssigneeSegment &&  segmentBy === CHART_CONST_INFO.ASSIGNEE) ? CHART_CONST_INFO.RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN : CHART_CONST_INFO.ACTIVATE_WORKGROUP_BY_DUEDATE_RESOLVED_TODAY_ASSIGNEE_DRILL_DOWN;
                    setselectedChart(activeChart);
                    setIsDrillDownActive(true);
                    fetchDataFromApi(activeChart, workgroupId, selectedDate, selectedReport);
                } else {
                    const activeChart = segmentBy === CHART_CONST_INFO.TAB_DUE_DATE ? CHART_CONST_INFO.ACTIVATE_DUEDATE_BY_USERS : CHART_CONST_INFO.ACTIVATE_STATUS_BY_USERS;
                    setselectedChart(activeChart);
                    setIsDrillDownActive(true);
                    fetchDataFromApi(activeChart, workgroupId, selectedDate);
                }

            }
        }
    };

    const ChartTitle = () => (
        <>
            {selectedReport === CHART_CONST_INFO.UPCOMING_DUE_DATES ?
                <h4 className='--chart_title' >
                    <div>
                        <strong>{CHART_CONST_INFO.TITLE}</strong>
                        <DatePicker
                            id="effectiveDate"
                            dateFormat="MM/dd/yyyy"
                            selected={selectedDate}
                            onChange={onSelectedDate}
                        />
                    </div>
                </h4> :
                <h4 className='--chart_title' >
                    <div>
                        <strong>{CHART_CONST_INFO.TITLE_RESOLVED_TODAY}</strong>
                    </div>
                </h4>

            }

        </>

    )
    const RenderByWorkGroup = () => {
        return (
            <div className='grid-row'>
                <div className={`chartContainer ${chartName}`}>
                    <div className='--charts_default'>
                        <ChartTitle />
                        {isDrillDownActive &&
                            <div className='--sub-heading'>
                                <span>
                                    <a href='#' onClick={() => {backToDetailedReport()} }>{CHART_CONST_INFO.BACK}</a>
                                    <strong>{selectedWorkGropeName}</strong>
                                </span>
                            </div>
                        }
                        {
                            chartData?.length > 0 ?
                                <BarChart
                                data={chartData}
                                toUserChart={toUserChart}
                                hTitle={isDrillDownActive ? CHART_CONST_INFO.TICKETS_COUNT : CHART_CONST_INFO.NUMBER_OF_TICKETS}
                                chartColors={chartColors}
                                selectedChart={selectedChart}
                                />
                                :<FormattedMessage id='selfDesignation.search.results.noRecordsFound.title' />
                        }
                        <div className='--chart_legend'>
                            <strong>{isDrillDownActive
                                    ? (selectedChart === CHART_CONST_INFO.RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN)  ? CHART_CONST_INFO.WORKGROUP : CHART_CONST_INFO.ASSIGNEE
                                    : (selectedChart === CHART_CONST_INFO.RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE) ? CHART_CONST_INFO.ASSIGNEE : CHART_CONST_INFO.WORKGROUP}</strong>
                            <ul>
                                {serviceResponse?.[0]?.slice(1)?.map((item, index) => (
                                    <li>
                                        <a
                                            data-tip
                                            ref={ref => tStatusRef = ref}
                                            data-for={`${item}-${index}_tooltip`}
                                            className="ds-u-font-size--small ds-text ds-u-measure--wide ds-u-color--muted ds-u-text-decoration--underline cursor--pointer"
                                            id={`${item}-${index}`}
                                        >
                                            <div
                                                className='--legend_button' id={`${item} ${index}`}
                                                style={{ background: `${defaultReportCoolers[index]}` }}
                                            />&nbsp;
                                            <a className={legendClassName[index]} href='#' id={index} onClick={(e)=>filterBasedOnLegend(e,item)}>{item}</a>
                                            {item.toUpperCase() === 'OPEN' &&
                                                <ReactTooltip
                                                    place="top"
                                                    type="light"
                                                    border={true}
                                                    borderColor={'black'}
                                                    effect="solid"
                                                    role="tooltip"
                                                    id={`${item}-${index}_tooltip`}
                                                    clickable={true}
                                                    delayHide={500}
                                                    delayShow={500}
                                                    delayUpdate={500}
                                                    className="ds-u-text-transform--capitalize"
                                                >
                                                    {"Unresolved and Untouched by Assignee"}
                                                </ReactTooltip>
                                            }

                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    return (
        <>
            { chartInfoData.isSpinning  && chartData.length < 1
                ? 
                    <Spinner message="Loading..." />
                :
                    <UpcomingDueDate 
                        segmentBy={ segmentBy }
                        setSegmentBy = { setSegmentBy }
                        selectedReport={selectedReport} 
                        RenderByWorkGroup={RenderByWorkGroup} 
                        changeReport={changeReport} 
                        showAssigneeSegment={ showAssigneeSegment }
                        idMapping={idMapping}
                        filterBySelectedWorkGroup = { filterBySelectedWorkGroup }
                        isDrillDownActive = { isDrillDownActive }
                        workGroupFilter = { workGroupFilter}
                        selectedChart={selectedChart}
                    />
            }
        </>

    )
}
export default UpcomingDueDateContainer;